import type {SubjectT} from '@freckle/educator-entities/ts/common/helpers/subjects'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {
  subjectBtnGroup,
  productButtonSelected,
  productButton,
} from './subject-button-group.module.scss'

type Props = {
  selectedSubject: SubjectT
  onSelectSubject: (subject: SubjectT) => void
  shouldShowEla: boolean
}

export function SubjectButtonGroup(props: Props) {
  const {shouldShowEla, selectedSubject, onSelectSubject} = props
  const {t} = useSafeTranslation()

  return (
    <div className={subjectBtnGroup} role="group">
      <Button
        style="secondary"
        className={selectedSubject === 'math' ? productButtonSelected : productButton}
        onClick={() => onSelectSubject('math')}
      >
        {t('Math')}
      </Button>
      {shouldShowEla ? (
        <Button
          style="secondary"
          className={selectedSubject === 'ela' ? productButtonSelected : productButton}
          onClick={() => onSelectSubject('ela')}
        >
          {t('ELA')}
        </Button>
      ) : null}
    </div>
  )
}
